<script>
import UiConfig from '../../config/ui'
import bus from '../../bus.js'

export default {
  async created () {
    try {
      const url = UiConfig.urls.auth.nuvemcallback + '?code=' + this.$route.query.code + '&state=' + this.$route.query.state
      const response = await fetch(url)

      if (!response.ok) {
        const data = await response.json().catch(() => ({}))
        const mensagens = {
          404: 'Serviço de autenticação não encontrado',
          400: data.err || 'Falha ao solicitar autenticação',
          401: data.err || 'Falha ao solicitar autenticação'
        }
        throw new Error(mensagens[response.status] || 'Falha ao solicitar autenticação')
      }

      const data = await response.json()
      window.localStorage.setItem('token', data.tokenSiop)
      window.localStorage.setItem('refreshToken', data.refreshToken)
      document.location = UiConfig.paths.default
    } catch (err) {
      bus.emit('siop-limpa-tudo')
      bus.emit('siop-erro', err.message || 'Falha ao solicitar autenticação')
      this.$router.push('paginainicial')
    }
  }
}
</script>
